import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseUserCoin, ApiResponseUserCoinHistories } from '@/api/responses/userCoins'

export namespace UserCoinsApi {
  /**
   * ユーザ別学びコイン保有数取得
   *
   * @returns ユーザの合計コイン数
   */
  export async function getUserCoin(): Promise<ApiResponseUserCoin> {
    return await ApiBase.get(`userCoins`)
  }

  /**
   * ユーザ別学びコイン獲得履歴一覧取得
   *
   * @param userId ユーザID
   * @param count 取得件数(指定しない場合、API側の最大取得件数が適用される)
   * @returns ユーザのコイン獲得履歴一覧
   */
  export async function getUserCoinHistories(userId: number, count?: number): Promise<ApiResponseUserCoinHistories> {
    const params = {}
    if (count) {
      Object.assign(params, { count: count })
    }
    return await ApiBase.get(`userCoins/${userId}`, params)
  }
}
